import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ப்ரஹ்ம யஜ்ஞம்</h1>
<h3>ஆசமனம்</h3>
  <h3>ப்ராணாயாமம்</h3>
  <div class="hint">
குறிப்பு:- நித்யம் செய்யவேண்டிய ப்ரஹ்ம யஜ்ஞத்திற்கும்
ஸ்மார்தர்கள் தர்பணத்திற்கு பிறகு செய்யும் ப்ரஹ்ம யஜ்ஞத்திற்கும்
வேறுபாடு இருக்கும். 
  </div>
  <img src="assets/img/vadakalai-symbol.jpg" class="img2">
  ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம் ப்ரஹ்ம யஜ்ஞேன யக்ஷ்யே<br>
  பகவாநேவ ஸ்வசேஷ பூதமிதம் ப்ரஹ்ம யஜ்ஞ கர்மாக்யம் ஸ்வஸ்மை 
  ஸ்வப்ரீதயே பகவாந் ஸ்வயமேவ காரயதி
  <hr class="new">
  <img src="assets/img/thenkalai-symbol.jpg" class="img2">
  ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம் ப்ரஹ்ம யஜ்ஞேன யக்ஷ்யே
  <hr class="new">

  <div class="hint">
ஜலத்தால் இரு உள்ளங்கைகளையும் அலம்பவும். 
  </div>
  <div class="sans">
  विद्युदसि विद्य मे पाप्मानमृतात् सत्यमुपैमि।।</div>

  <div class="hint">
        <img src="assets/img/brahma-yajgnam.jpg" class="img2">
ஆசமனம் பண்ணி, சுத்த இடத்தில் உட்கார்ந்து, இடது துடைமேல் வலது கால்
போட்டுக்கொண்டு பின் வரும் மந்திரங்களை ஜபிக்கவும். வேத மந்திரம் 
உச்சரிப்புச் சரியாகச் சொல்லவேண்டும் என்பதால் 
மந்திரங்கள் தேவநாகரியில் மட்டுமே வழங்கப்பட்டுள்ளன.</div>
<div class="svk">
தயவுசெய்து, ப்ரஹ்ம யஜ்ஞம் செய்யும் அளவிற்கு ச்ரத்தை
உள்ள தாங்கள், வெறும் 56 எழுத்துக்களே உள்ள தேவநாகரி 
எழுத்துக்களின் உச்சரிப்பை ஒரு 56 நாட்கள் பழகி அதன் பின்
ப்ரஹ்ம யஜ்ஞம் உச்சரிப்பு பிசகாமல் செய்வதே சிறப்பு. 
  </div>
  <div class="sans">
        ओं भू: तत्सवितुर्वरेणियम्,<br>
ओं भुव: भर्गो देवस्य धीमहि,<br>
ओं सुव: धियो योन: प्रचोदयात्।<br>

ओं भू: तत्सवितुर्वरेणियम्,<br>
 भर्गो देवस्य धीमहि,<br>
ओं भुव: धियो योन: प्रचोदयात्।<br>
ओं सुव: तत्सवितुर्वरेणियम्,<br>
 भर्गो देवस्य धीमहि, धियो योन: प्रचोदयात्। <br>
ओं भूर्भुवस्सुव: तत्सवितुर्वरेणियम्,<br>
 भर्गो देवस्य धीमहि, धियो योन: प्रचोदयात्। <br>
हरि: ॐ । अग्निमीळे पुरोहितं - यज्ञस्य - देवमृत्विजम् ।<br>
होतारं - रत्नधातमं । हरि: ॐ ।<br>
हरि: ॐ । इषेत्वा - उूर्जेत्वा - वायवस्थ - उपायवस्थ - देवोव: - सविता -
प्रार्पयत् श्रेष्टतमाय - कर्मणे । हरि: ॐ ।<br>

हरि: ॐ । अग्न आयाहि - वीतये - गृणान: - हव्यदातये ।<br>
निहोता - सत्सि - बर्हिषि । हरि: ॐ ।<br>
हरि: ॐ । शन्नोदेवेरभिष्टये - आपोभवन्तु - पीतये - शँयोरभिस्रवन्तुन: । हरि: ॐ ।

  </div>
  <div class="hint">
இதன் பிறகு வேதத்தில் ஒவ்வொரு நாளும் (ஒரு நாளைக்குக் 
குறைந்தது ஒரு ப்ரச்னம்) ஒவ்வொரு ப்ரச்னமாக 
சொல்லிக்கொண்டு வரவேண்டும். அதன் பின் கீழ்கண்டவாறு முடிக்கவேண்டும். 
  </div>
  <div class="sans">
        ओं सत्यं तप: श्रद्धायां जुहोमि ।<br>

        ओं नमो ब्रह्मणे नमो अस्तु अग्नये, नम: पृथिव्यै,
        नम ओषधीभ्य:।<br>
        नमो वाचे नमो वाचस्पतये नमो विष्णवे बृहते करोमि।।<br>
        ओं नमो ब्रह्मणे नमो अस्तु अग्नये, नम: पृथिव्यै,
        नम ओषधीभ्य:।<br>
        नमो वाचे नमो वाचस्पतये नमो विष्णवे बृहते करोमि।।<br>
        ओं नमो ब्रह्मणे नमो अस्तु अग्नये, नम: पृथिव्यै,
        नम ओषधीभ्य:।<br>
        नमो वाचे नमो वाचस्पतये नमो विष्णवे बृहते करोमि।।
<hr class="new">
        वृष्टिरसि वृश्चमे पाप्मानमृतात् सत्यमुपागाम्।।
  </div>
  <div class="hint">
என்று ஜலம் தொட்டு இரு உள்ளங்கைகளைத் துடைக்கவும். 
  </div>
  <img src="assets/img/vadakalai-symbol.jpg" class="img2">
 
  பகவாநேவ ஸ்வசேஷ பூதமிதம் ப்ரஹ்ம யஜ்ஞ கர்மாக்யம் ஸ்வஸ்மை 
  ஸ்வப்ரீதயே பகவாந் ஸ்வயமேவ காரிதவான். 
  <hr class="new">
  <img src="assets/img/thenkalai-symbol.jpg" class="img2">
  காயே ந வாசா மநஸே இந்த்ரியைர் வா புத்யா ஆத்மநா வா
  ப்ருஹ்ருதே: கரோமி யத்யத் ஸகலம் பரஸ்மை
  ஸ்ரீமந் நாராயணாயேதி ஸமர்ப்பயாமி. 
  <hr class="new">
  <div class="hint">
ப்ரஹ்மயஜ்ஞம் ஸமாப்தம்
  </div>`;

const BrahmayajgnamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="ப்ரஹ்ம யஜ்ஞம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default BrahmayajgnamPage;
